module.exports = __webpack_public_path__ + "static/media/blackFriday.701f69b7.jpg";